import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth-context.js';
export function AdminPage() {
    const { user } = useAuth();
    if (user.role !== 'admin' && user.role !== 'super_admin')
        return _jsx("p", { children: "\u062F\u0633\u062A\u0631\u0633\u06CC \u0646\u062F\u0627\u0631\u06CC\u062F." });
    return (_jsxs("div", { className: "grid grid-cols-2 gap-3", children: [_jsx(Link, { to: "/admin/roster", className: "bg-white p-4 rounded shadow", children: "\u0648\u06CC\u0631\u0627\u06CC\u0634 \u0634\u06CC\u0641\u062A" }), _jsx(Link, { to: "/admin/staff", className: "bg-white p-4 rounded shadow", children: "\u06A9\u0627\u0631\u06A9\u0646\u0627\u0646" })] }));
}
